module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/04_plates#h2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Plates")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/05_maps#h3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/07_acknow#h4"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/08_foreword#h5"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/09_authors#h6"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10_part01#h7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART I: INTO THE SALIENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/12_chapter01#h8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" A Vision of the World’s End")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/13_chapter02#h9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Temporary Gentlemen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/14_chapter03#h10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" A Very Fine Lot Indeed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/15_chapter04#h11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula")]), _vm._v("’s Fate")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter05#h12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Of Knaves and Jokers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter06#h13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" The Sword of Deborah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter07#h14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" In Honour Bound")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_part02#h15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART II: THE BATTLE OF PASSCHENDAELE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter08#h16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Ray of Sunshine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter09#h17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('span', {
    staticClass: "space1"
  }, [_vm._v(" Crossing the Canal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter10#h18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Into the Pillar of Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter11#h19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Deborah")]), _vm._v(", the Dead Man and the Drummer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter12#h20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Failure is an Orphan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter13#h21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Dead Never Stirred")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter14#h22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Bogs of Passchendaele")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_part03#h23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART III: GATHERING FORCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter15#h24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Coming of Frank Heap")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter16#h25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Heap’s Progress")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter17#h26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" ‘The Best Company of the Best Battalion’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter18#h27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Redundant Oddments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter19#h28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Out of the Salient")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter20#h29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" High Days and Highlanders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/35_part04#h30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART IV: THE BATTLE OF CAMBRAI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter21#h31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 21")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Into Hiding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter22#h32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 22")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" On the Silent Front")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter23#h33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 23")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" ‘Things Fall Apart’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter24#h34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 24")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" To Shake Mightily the Earth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter25#h35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 25")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" ‘Now For It!’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter26#h36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 26")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Till the Last Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/43_part05#h37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART V: BEYOND THE GRAND RAVINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter27#h38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 27")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" A Mountain to Climb")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter28#h39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 28")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Crack of Doom")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter29#h40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 29")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Into the Hurricane")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter30#h41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 30")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Green Fields Beyond")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter31#h42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 31")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Like a Boar at Bay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter32#h43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 32")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" A Bitter Evening")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter33#h44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 33")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" The Chance Was Gone")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/51_part06#h45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART VI: ACROSS THE THRESHOLD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter34#h46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 34")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Sticking to their Guns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter35#h47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 35")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" ‘The Fates Fought Against Us’")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter36#h48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 36")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" A Peaceful, Unexceptional Place")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter37#h49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 37")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Varied Fortunes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter38#h50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 38")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Rosemary for Remembrance")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter39#h51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 39")]), _vm._v(" "), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Weapon of Friendship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/58_appendix01#h52",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix A: Order of Battle of D Battalion Tank Corps, and associated infantry and tank units, at Battle of Passchendaele (22 August 1917)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/59_appendix02#h53",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix B: Order of Battle of British and German units at Flesquières in Battle of Cambrai (20 November 1917)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/60_appendix03#h54",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix C: Order of Battle of D Battalion Tank Corps at Battle of Cambrai (20 November 1917)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/61_notes#h55",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/62_sources#h56",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c438d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_contents.vue
// module id = 69
// module chunks = 0